import React from 'react';
import RmsPostFormPage from '../RmsPostFormPage';

/**
 * RequestForReferral
 * ------------------
 * Purpose:
 *   Renders the "Request for Referral" post-account form for both school-initiated
 *   and guardian-initiated referrals.
 *
 * Guardian Nomination Flow (School-initiated referrals):
 *   - School user completes the `guardian_nomination` step via NominationField modal
 *   - The nomination data is stored as an object under `guardian_nomination` key in form answers
 *   - On form submission, the backend (rmsSubmitForm) automatically:
 *     1. Creates a participant record for the guardian
 *     2. Creates an accountInvitation record
 *     3. Sends a welcome email to the nominated guardian
 *   - No additional frontend API calls are needed; the form submission handler does everything
 *
 * School Nomination Flow (Guardian-initiated referrals):
 *   - Guardian nominates school representative(s) via similar nomination flow
 *   - Backend handles invite creation on form submission (not yet implemented on frontend)
 */
export default function RequestForReferral() {
  /**
   * beforeNext callback
   * Called before advancing to the next step. Returns { proceed: true/false }.
   * Currently we don't block on nomination step since validation happens in the modal.
   */
  const beforeNext = React.useCallback(async (currentStep) => {
    try {
      // Do not log the full answers snapshot — it contains PII (nominee name/email/phone) (TD-22).
      if (!currentStep) {
        return { proceed: true };
      }

      // For nomination type, the modal already validated and saved the data
      // No additional blocking needed on step advance
      if (currentStep?.type === 'nomination') {
        // eslint-disable-next-line no-console
        console.log('[RMS][RFR] Nomination step - data saved via modal, proceeding');
        return { proceed: true };
      }

      return { proceed: true };
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[RMS][RFR] beforeNext error', e);
      return { proceed: false };
    }
  }, []);

  return (
    <RmsPostFormPage
      formKey="requestForReferral"
      afterSubmitRoute={(patientRecordId) => `/rms/patient/${encodeURIComponent(patientRecordId)}/overview`}
      backToRoute={(patientRecordId) => `/rms/patient/${encodeURIComponent(patientRecordId)}/overview`}
      beforeNext={beforeNext}
    />
  );
}
